var map = {
	"./1.gif": "YUdz",
	"./2.gif": "8YQ+",
	"./3.gif": "f/ma",
	"./4.gif": "hgNK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cA6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f1 ^\.\/.*\.gif$
// module id = 0cA6
// module chunks = 1